var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "video-container", class: _vm.bottomPadding },
    [
      _vm.isSkeleton
        ? _c(
            "section",
            { staticClass: "skeleton-container" },
            [
              _c("van-skeleton", {
                staticClass: "video-skeleton",
                attrs: { row: 1 }
              }),
              _vm._v(" "),
              _c("van-skeleton", {
                staticClass: "mt-12",
                attrs: { title: "", row: 2 }
              }),
              _vm._v(" "),
              _c("van-skeleton", {
                staticClass: "mt-12",
                attrs: { avatar: "", title: "", row: 3 }
              }),
              _vm._v(" "),
              _c("van-skeleton", {
                staticClass: "mt-12",
                attrs: { title: "", row: 2 }
              }),
              _vm._v(" "),
              _c("van-skeleton", {
                staticClass: "video-skeleton-item",
                attrs: { row: 2 }
              }),
              _vm._v(" "),
              _c("van-skeleton", {
                staticClass: "video-skeleton-item",
                attrs: { row: 2 }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isSkeleton,
              expression: "!isSkeleton"
            }
          ]
        },
        [
          _c("div", { staticClass: "primary-video" }, [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.mobileLiveVideo,
                  expression: "!mobileLiveVideo"
                }
              ],
              staticClass: "video-window",
              attrs: { id: "player" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isApp && _vm.mobileLiveVideo,
                    expression: "!isApp && mobileLiveVideo"
                  }
                ],
                staticClass: "live-video"
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "open-app",
                    on: {
                      click: function($event) {
                        return _vm.openApp(_vm.mediaId, _vm.isLive)
                      }
                    }
                  },
                  [
                    _vm._v("请打开app观看直播"),
                    _c("van-icon", { attrs: { name: "share-o", size: "20" } })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isApp && _vm.mobileLiveVideo,
                  expression: "isApp && mobileLiveVideo"
                }
              ],
              staticClass: "app-live-video",
              on: {
                click: function($event) {
                  return _vm.openApp(_vm.mediaId, _vm.isLive)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "video-about-message" }, [
            _c("div", { staticClass: "video-title" }, [
              _vm._v(_vm._s(_vm.videoDetail.title))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "video-info" }, [
              _c("section", { staticClass: "flex" }, [
                _c("div", { staticClass: "avatar" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.videoDetail.authorImg,
                      alt: "",
                      width: "100%",
                      height: "100%"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "source-name" }, [
                  _vm._v(_vm._s(_vm.videoDetail.author))
                ])
              ]),
              _vm._v(" "),
              _c("section", [
                _c("div", { staticClass: "publish-time" }, [
                  _vm._v(
                    _vm._s(_vm._f("formatDate")(_vm.videoDetail.publishTime))
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.videoDetail.isLive
              ? _c(
                  "section",
                  { staticClass: "video-message" },
                  [
                    _c(
                      "van-row",
                      { staticClass: "message-item" },
                      [
                        _c(
                          "van-col",
                          { staticClass: "label", attrs: { span: "5" } },
                          [_vm._v("会议类型")]
                        ),
                        _vm._v(" "),
                        _c("van-col", { staticClass: "label-value" }, [
                          _vm._v(_vm._s(_vm.videoDetail.property || "--"))
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "van-row",
                      { staticClass: "message-item" },
                      [
                        _c(
                          "van-col",
                          { staticClass: "label", attrs: { span: "5" } },
                          [_vm._v("相关公司")]
                        ),
                        _vm._v(" "),
                        _c("van-col", { staticClass: "label-value" }, [
                          _vm._v(_vm._s(_vm.relatedCompany))
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "van-row",
                      { staticClass: "message-item" },
                      [
                        _c(
                          "van-col",
                          { staticClass: "label", attrs: { span: "5" } },
                          [_vm._v("公司类型")]
                        ),
                        _vm._v(" "),
                        _c("van-col", { staticClass: "label-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("convertStockMarket")(
                                _vm.videoDetail.companyType
                              )
                            )
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "more-video" }, [
            _c("div", { staticClass: "more-video-tag" }, [_vm._v("更多视频")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-list" },
              _vm._l(_vm.recommendVideos, function(video) {
                return _c(
                  "div",
                  {
                    key: video.id,
                    staticClass: "video-item",
                    on: {
                      click: function($event) {
                        _vm.openApp(
                          video.id,
                          video.isLive && video.status === 1 ? "1" : "0"
                        )
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "tag",
                      style: _vm.backgroundImageUrl(video)
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "more-video-item",
                      style: "background-image: url(" + video.imageUrl + ")"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "more-video-title" }, [
                      _vm._v(_vm._s(video.title))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "more-video-info" }, [
                      _c("div", { staticClass: "more-video-source-name" }, [
                        _vm._v(_vm._s(video.author))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "more-video-publish-time" }, [
                        _vm._v(_vm._s(_vm._f("formatDate")(video.publishTime)))
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("open-app", {
            attrs: {
              "is-show": !_vm.isApp && _vm.isAndroidOrIos,
              "media-id": _vm.$route.query.mediaId,
              "is-live": _vm.isLive
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }